import { Container } from "./styled";
import React, { useEffect, useState } from "react";
import firebase from "../../../lib/fire";
import Modal from "../../../modal";
import secureLocalStorage from "react-secure-storage";

const CardsCopy = ({ play, index }) => {
  const [showModal, setShowModal] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [optionsToShow, setOptionsToShow] = useState(null);
  const userLocal = secureLocalStorage.getItem("userLocal");
  const userAuth = secureLocalStorage.getItem("userId");

  var userId = userAuth;

  const handleProjectClick = (PlayID) => {
    window.location.replace(`/app/playVideos/${PlayID}`); //go to playVideo page
  };
  //------------ END GET USERS PLAYS FROM DATABASE -------------

  function toggleModal() {
    setShowModal(!showModal);
    if (!showModal) {
      document.getElementById("modal").style.display = "flex";
    } else {
      document.getElementById("modal").style.display = "none";
    }
  }

  function confirmDeleteClick(play) {
    var ref = firebase.database().ref(`/users/0/${userId}/plays/${play}`);
    ref.remove().then(() => {
      let user = userLocal;
      user.plays.splice(play, 1);
      secureLocalStorage.setItem("user", user);
      setShowModal(false);
      document.getElementById("modal").style.display = "none";
      window.location.reload(false);
    });
  }
  const showHistoryOptions = (id) => {
    let optionsDiv = document.getElementsByClassName(`options-${id}`)[0];
    let optionsToRemove = document.getElementsByClassName(`options`);
    for (var i = 0; i < optionsToRemove.length; i++) {
      optionsToRemove[i].classList.remove("active");
    }
    if (optionsDiv.classList.contains("active")) {
      optionsDiv.classList.remove("active");
    } else {
      optionsDiv.classList.add("active");
    }
  };
  useEffect(() => {
    if (showOptions) showHistoryOptions(optionsToShow);
  }, [showOptions]);
  return (
    <Container key={index}>
      {showModal ? (
        <Modal>
          <div className="modal">
            <div class="modal-img-container">
              <img
                style={{ width: "30%" }}
                src="/assets/delete-icon.svg"
                className="trash-can-button"
                alt=""
              />
              <h1>Eliminar jugada</h1>
              <p>
                Estás seguro que deseas eliminar esta jugada?<br></br>
                <span className="delete-warning">
                  No será posible recuperarla.
                </span>
              </p>
            </div>
            <div className="delete-modal-buttons">
              <button
                className="delete-button"
                onClick={() => {
                  confirmDeleteClick(index);
                }}
              >
                Eliminar
              </button>
              <button
                className="cancel-button"
                onClick={() => {
                  toggleModal();
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </Modal>
      ) : null}
      <div className="card-container">
        <div
          className="options-container"
          onClick={(e) => {
            setShowOptions(!showOptions);
            setOptionsToShow(index);
          }}
        >
          <p className="menu">...</p>
          {showOptions ? (
            <ul className={`options options-${index}`}>
              <li className="edit">
                <img src="/assets/edit-icon.svg" alt="" />
                <a href={`/app/edit-animation/${index}?id=${index}`}>Editar</a>
              </li>
              <li
                className="delete"
                onClick={() => {
                  toggleModal();
                }}
              >
                <img
                  src="/assets/delete-icon.svg"
                  className="trash-can-button"
                  alt=""
                />
                <p>Eliminar</p>
              </li>
            </ul>
          ) : null}
        </div>
        <div
          className="data-container"
          id={index}
          onClick={() => {
            handleProjectClick(index);
          }}
        >
          <img
            src="/assets/card-placeholder.jpg"
            alt="placeholder for animations card"
          />
          <div>
            <h2>{play.name}</h2>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CardsCopy;
